export const useStyles = (theme) => ({
  root: {
    display: "flex",
    marginTop: 10,
    marginLeft: 0,
  },
  tab: {
    width: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  buttonStyle: {
    backgroundColor: "#181818 !important",
    borderRadius: 10,
    color: "#ffd31a",
    fontSize: 16,
    fontWeight: "bold",
    fontFamily: "Open Sans",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#ffd31a !important",
      color: "#181818",
    },
  },
});
